<template xmlns:v="http://www.w3.org/1999/XSL/Transform">
    <templateItem
        v-bind:metadata="metadata"
        v-bind:isSelected="isSelected"
        v-bind:parentId="parentId"
        v-bind:classes="classes"
        v-bind:styles="cssRules"
        v-bind:controlsStyle="'right: -33px; top: -26px;'"
        v-on:delete-item="$emit('delete-block', $event)"
        v-on:select-item="$emit('select-block', $event)"
        v-on:move-item="$emit('move-block', $event)"
        v-on:lock-item="$emit('lock-block', $event)"
        v-on:unselect-all="selectedRow = null"
        v-bind:locked="locked"
        v-bind:isParent="isParent"
        >

        <template v:slot="settings" v-if="showSettings">
            <TemplateBlockSettings
                v-bind:width="width"
                v-bind:color="metadata.style.color"
                v-bind:border="metadata.style.border"
                v-bind:borderColor="metadata.style.borderColor"
                v-bind:radius="metadata.style.radius"
                v-on:change-color="$emit('change-color', $event)"
                v-on:change-border-color="$emit('change-border-color', $event)"
                v-on:change-width="$emit('change-width', $event)"
                v-on:set-border="$emit('set-border', $event)"
                v-on:change-radius="$emit('change-radius', $event)"
            />
        </template>

        <div v-if="rowsReady">
            <templateRow
                v-for="row in sortedRows"
                v-bind:key="row._key"
                v-bind:id="row.Id"
                v-bind:currentTemplateId="currentTemplateId"
                v-bind:templateId="row.TemplateId"
                v-bind:parentId="row.ParentId"
                v-bind:isSelected="selectedRow === row"
                v-bind:locked="row.IsLocked"
                v-bind:lockStateChanged="row.LockStateChanged"
                v-bind:rowTypeId="row.RowTypeId"
                v-bind:blockId="row.BlockId"
                v-bind:metadata="row.Metadata"
                v-bind:columns="row.Columns"
                v-bind:rowTypes="rowTypes"
                v-bind:parentColor="metadata.style.color"
                v-on:select-row="selectedRow = row"
                v-on:delete-row="deleteRow($event)"
                v-on:change-color="row.Metadata.style.color = $event"
                v-on:move-row="moveRow($event.old, $event.new)"
                v-on:lock-row="toggleRowLock(row, $event)"
                v-on:item-added="$emit('item-added')"
            >
            </templateRow>
        </div>

        <div v-if="!lockedByParent" class="row">
            <div class="col-auto mx-auto">
                <a 
                    href="javascript:void(0)" 
                    class="mdb-icon-btn new"
                    data-toggle="tooltip"
                    v-on:click.stop="pickingRow = true"
                    v-bind:title="tooltips.insertRow"
                >
                    <i class="fa fa-plus-circle fa-2x"></i>
                </a>

                <div 
                    v-if="pickingRow"
                    v-on:mouseleave="pickingRow = false"
                    class="item-picker text-center"
                >
                    <div class="row">
                        <div class="col-12 item-picker-header">
                            <span>
                                {{resource('TemplateBlock_SchemePicker_Title')}}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div v-if="rowsReady" class="col-12 item-picker-content">
                            <table width="100%">
                                <tr 
                                    v-for="row in rowTypes"
                                    :key="row.id"
                                    v-bind:id="row.Id"
                                    v-on:click.stop="addRow(row.Id)"
                                >
                                    <td
                                        v-for="column in row.Value.columns"
                                        :key="column.id"
                                        v-bind:colspan="getColumnSize(column)"
                                    >
                                        <div class="item-picker-column"></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </templateItem>
</template>

<script>
    import {insertRowTooltip} from "../tooltips";

    import {applyDefaults, rowDefaults} from "../defaults";

    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../../Util/Mixins/tooltips";

    import selectableItemMixin from '../Mixins/selectable-item'
    import resourceMixin from "../../../Util/Mixins/resources";
    import guidMixin from '../../../Util/Mixins/guid';
    import dataStore from '../Util/data-store'
    
    import {DEFAULT_SETTINGS_DATASTORE_KEY} from "./Template.vue";
    import Row from './TemplateRow.vue';
    import TemplateItem from './TemplateItem.vue';
    import TemplateBlockSettings from './Settings/TemplateBlockSettings.vue';
    
    import templateApi from '../../../Api/template-manager';

    export default {
        name: 'template-block',
        mixins: [resourceMixin, autoInitializeTooltipsMixin, guidMixin, selectableItemMixin],
        components: {
            'TemplateRow': Row,
            'TemplateItem': TemplateItem,
            'TemplateBlockSettings': TemplateBlockSettings
        },
        created () {
            const vm = this;

            templateApi.getRowTypes().then((rowTypes) => {

                rowTypes.forEach(function (row) {
                    row.Value.columns.forEach(function(column){
                        column.id = vm.guid();
                    }); 
                });

                vm.rowTypes = rowTypes;
            });
        },
        methods: {
            addRow(rowType) {
                const vm = this;
                vm.pickingRow = false;

                let row = {
                    _key: vm.guid(),
                    BlockId: vm.id,
                    TemplateId: vm.currentTemplateId,
                    RowTypeId: rowType,
                    IsLocked: false,
                    LockStateChanged: false,
                    Metadata: {
                        index: vm.lastRow + 1
                    },
                    Columns: []
                };
                
                applyDefaults(rowDefaults, row.Metadata);

                vm.rows.push(row);
                this.$emit('item-added');
            },
            toggleRowLock(row, locked) {
                row.IsLocked = locked;
                row.LockStateChanged = !row.LockStateChanged;
            },
            deleteRow(index) {
                const rows = this.rows;
                rows.splice(index-1,1);
                this.reIndex();
            },
            moveRow(oldIndex, newIndex) {
                const vm = this;

                const current = vm.rows.find(r => r.Metadata.index === oldIndex);
                const swapTarget = vm.rows.find(r => r.Metadata.index === newIndex);
                
                if(!swapTarget || !current){
                    return;
                }
                
                current.Metadata.index = newIndex;
                swapTarget.Metadata.index = oldIndex;
            },
            getColumnSize(classes) {
                let arr = classes.split(' ');
                let result = '';

                arr.forEach(function (c) {
                    if(c.startsWith('col')) {
                        let arr2 = c.split('-');
                        result = arr2[arr2.length-1];
                    }
                });

                return result;
            },
            reIndex() {
                //Remove gaps from indexing
                this.sortedRows.forEach((row, index) => {
                    row.Metadata.index = index + 1;
                });
            }
        },
        watch: {
            selectedRow(value) {
                //Upon selecting a row, also select the block
                if(value){
                    this.emitSelection('select-block', this.metadata);
                }
            }
        },
        computed: {
            lockedByParent() {
                return this.locked && this.isParent;
            },
            showSettings() {
                return this.isSelected && !this.lockedByParent;
            },
            lastRow() {
                return this.rows.length;
            },
            rowsReady() {
                return this.rowTypes != null;
            },
            sortedRows() {
                return this.rows.sort((left, right) => {
                    if(left.Metadata.index < right.Metadata.index)
                        return -1;
                    if(left.Metadata.index > right.Metadata.index)
                        return 1;
                    return 0;
                });
            },
            backgroundColor() {
                return this.metadata.style.color != '' ? this.metadata.style.color : this.parentColor;
            },
            width: {
                get(){
                    //Only use metadata width when configured
                    //otherwise, fallback to default
                    if(this.metadata.style.width){
                        return this.metadata.style.width;
                    } 
                   
                   return dataStore.get(DEFAULT_SETTINGS_DATASTORE_KEY).blockWidth;
                },
                set(value){
                    this.metadata.style.width = value;
                }
            },
            cssRules() {
                const border = this.metadata.style.border ? 
                    'border: 1px solid ' + this.metadata.style.borderColor :
                    '';

                const rules = [
                    'margin-bottom: ' + this.settings.margin + 'px',
                    'border-radius: ' + this.metadata.style.radius + 'px',
                    border,
                    'background-color: ' + this.backgroundColor,
                ];

                if(this.metadata.style.width !== undefined){
                    rules.push( 'width: ' + this.metadata.style.width + 'px');
                }

                return rules.join(';');
            },
            isParent() {
                return this.currentTemplateId.toLowerCase() !== this.templateId.toLowerCase();
            },
            classes(){
                const classList = [
                    'mx-auto',
                    'template-block'
                ];

                if(this.isSelected){
                    classList.push('selected-block');
                }

                return classList.join(' ');
            }
        },
    	data() { 
            return {
                tooltips: {
                    insertRow: insertRowTooltip
                },
                pickingRow: false,
                rowTypes: null,
                selectedRow: null
            };
        },
        props: {
            id: {
                type: String,
                required: false
            },
            parentId: {
                type: String,
                default: null
            },
            locked: {
                type: Boolean,
                default: false
            },
            lockStateChanged: {
                type: Boolean,
                required: true
            },
            isSelected: {
                type: Boolean,
                required: true
            },
            currentTemplateId: {
                type: String,
                required: true
            },
            templateId: {
                type: String,
                required: true
            },
            pageId: {
                type: String,
                required: false
            },
            metadata: {
                type: Object,
                required: true,
                default: function () {
                    return { 
                        index: 0,
                        style: {
                            border: true
                        }
                    };
                }
            },
            settings: {
                type: Object,
                required: true
            },
            rows: {
                type: Array,
                required: true
            },
            parentColor: {
                type: String,
                default: function () {
                    return '#ffffff';
                }
            }
        }
    };
</script>

<style scoped src="../Style/template-block.scss" lang="scss">
</style>
